// extracted by mini-css-extract-plugin
export default {"wrapper":"iaYQT","secondary":"amcGT","primary":"YRHG1"};